import FJFontBase64Manager from '../font/FJFontBase64Manager';
import FJFontManager from '../font/FJFontManager';
import FJArrayUtil from '../../util/FJArrayUtil';

class FJFontLoader {
    constructor() {
        this._fonts = [];
    }

    /**
     * @desc 添加字体数据
     * @param fontDataList
     */
    addFontData(fontDataList) {
        fontDataList.forEach(fontData => {
            const key = this.getFontKey(fontData);
            const { text = '' } = fontData;
            let glyphs = this._getGlyphs(text);
            if (!this._fonts[key]) {
                this._fonts[key] = {
                    glyphs: FJArrayUtil.uniq(glyphs),
                    isAllGlyphs: false,
                    fontName: fontData.fontName,
                    bold: fontData.bold,
                    italic: fontData.italic,
                    fontPath: fontData.fontPath,
                    version: 0,
                };
            } else if (!this._fonts[key].isAllGlyphs) {
                let newGlyphs = FJArrayUtil.uniq([...glyphs, ...this._fonts[key].glyphs]);
                if (newGlyphs.length !== this._fonts[key].glyphs.length) {
                    // 重置base64，重新加载
                    this._fonts[key].glyphs = newGlyphs;
                    this._fonts[key].version++;
                    this._fonts[key].base64 = null;
                }
            }
        });
    }

    /**
     * @desc 获取字体数据
     * @param fontDataList
     * @returns {Promise<Macie2.BucketCountByEffectivePermission.unknown>}
     */
    async loadFont(fontDataList) {
        return new Promise((resolve, reject) => {
            let promiseList = [];
            for (let i = 0; i < fontDataList.length; i++) {
                const key = this.getFontKey(fontDataList[i]);
                promiseList.push(this.loadFontWithKey(key));
            }
            Promise.allSettled(promiseList)
                .then(data => {
                    resolve(data.filter(item => item.status === 'fulfilled').map(item => item.value));
                })
                .catch(e => {
                    reject(e);
                });
        });
    }

    /**
     * @desc 通过字体key获取字体数据
     * @param key
     * @returns {Promise<Macie2.BucketCountByEffectivePermission.unknown>}
     */
    async loadFontWithKey(key, fontBuffer = null) {
        if (!this._fonts[key]) {
            throw new Error('Font is not exist, you need add fontData first.');
        }

        let fontItem = this._fonts[key];
        if (fontItem.base64) {
            return fontItem;
        }

        const version = fontItem.version;
        const { base64, isAllGlyphs } = await FJFontBase64Manager.getFontBase64(fontItem, fontBuffer);
        if (version === fontItem.version) {
            fontItem.base64 = base64; // 缓存base64
            fontItem.isAllGlyphs = isAllGlyphs;
            return fontItem;
        } else {
            return await this.loadFontWithKey(key, fontBuffer);
        }
    }

    /**
     * 获取字符集
     * @param text
     * @returns {*[] | *[]}
     * @private
     */
    _getGlyphs(text) {
        let glyphsArray = text.replace(/\s+/g, '').replace(/\n/g, '').split('');
        glyphsArray.push(' ');
        return glyphsArray;
    }

    /**
     * @desc 获取字体的key
     * @param fontData
     * @returns {string}
     */
    getFontKey(fontData) {
        const { fontName, bold, italic } = fontData;
        const { disableBold, disableItalic } = FJFontManager.fontStyleDisableData(fontName);
        const boldStr = bold && !disableBold ? 'bold' : 'normal';
        const italicStr = italic && !disableItalic ? 'italic' : 'normal';
        return `${fontName}-${boldStr}-${italicStr}`;
    }
}

let _instance = new FJFontLoader();
export default _instance;
